import format from 'date-fns/format';
import React from 'react';
import CalendarHeader from './CalendarHeader';
import CalendarTimes from './CalendarTimes';
import CalendarWeek from './CalendarWeek';
import * as Styled from './styled';
import CalendarSubmit from './CalendarSubmit';
import { useTheme } from 'styled-components';

const Calendar = (props) => {
  const {
    month,
    year,
    selectedDate,
    isDateSelected,
    onDateSelected,
    onChangeDate,
    onSubmitDate,
    daysTimes,
  } = props;
  const theme = useTheme();
  const times = daysTimes.get(format(selectedDate, 'yyyy-MM-dd'));

  return (
    <Styled.Container dir="ltr">
      {/*
      // @ts-ignore */}
      <CalendarHeader daysTimes={daysTimes} month={month} year={year} onChangeDate={onChangeDate} />
      <Styled.Body>
        <CalendarWeek
          // @ts-ignore
          daysTimes={daysTimes}
          month={month}
          year={year}
          isDateSelected={isDateSelected}
          onDateSelected={onDateSelected}
        />
      </Styled.Body>
      {times && times.length > 1 && (
        <CalendarTimes times={times} selectedDate={selectedDate} onSelectDate={onDateSelected} />
      )}
      {theme.isMobile && <CalendarSubmit selectedDate={selectedDate} onSubmitDate={onSubmitDate} />}
    </Styled.Container>
  );
};

export default Calendar;
